export const isDateToday = (date) => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  // Compare the year, month, and day values of the two dates
  return `${year}-${month}-${day}` === date;
};
export const DATE_FORMAT = "YYYY-MM-DD";
